import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { CopyComponent } from '../../../components/CopyComponent';
import React from 'react';
import { getTableDate } from '../disputes/disputes-data';
import { StatusBadge } from '../../../components/status/StatusBadge';

export enum AccountApplicationTableAccessorKey {
	id = 'id',
	companyName = 'companyName',
	modifiedOn = 'modifiedOn',
	statusName = 'statusName'
}

export const defaultAccountApplicationColumnSizing = {
	[AccountApplicationTableAccessorKey.id]: 100,
	[AccountApplicationTableAccessorKey.companyName]: 100,
	[AccountApplicationTableAccessorKey.modifiedOn]: 100,
	[AccountApplicationTableAccessorKey.statusName]: 100,
};


export const defaultAccountApplicationColumns: MRT_ColumnDef<any>[] = [
	{
		accessorKey: AccountApplicationTableAccessorKey.id,
		header: 'Id',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black fs-7"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<CopyComponent value={renderedCellValue} title="Merchant Id"/>
					<div className="ms-2">{renderedCellValue}</div>
				</TableCell>
			);
		}
	},
	{
		accessorKey: AccountApplicationTableAccessorKey.companyName,
		header: 'Name',
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Name</span>,
		enableSorting: false,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fw-bolder">{renderedCellValue}</div>
			</TableCell>
		)
	},
	{
		accessorKey: AccountApplicationTableAccessorKey.modifiedOn,
		header: 'Modified date',
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Modified date</span>,
		enableSorting: false,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{
					renderedCellValue
						? (
							<div className="w-100px">
								{getTableDate(renderedCellValue, true)}
							</div>
						) : '-'
				}
			</TableCell>
		)
	},
	{
		accessorKey: AccountApplicationTableAccessorKey.statusName,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<StatusBadge status={renderedCellValue}/>
			</TableCell>
		)
	},
];
